// extracted by mini-css-extract-plugin
export default {"menuBlock":"HE-z","title":"IE-z","nav":"JE-z","flexCell":"KE-z","facetLink":"LE-z"};